// src/store/slices/deviceSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { device } from "../../types";

// Initial state for the device slice
const initialState: device.DeviceStateType = {
  availableDevices: {
    isLoading: false,
    data: [],
    error: null,
  },
  connectedDevices: {
    isLoading: false,
    data: [],
    error: null,
  },
};

// Define the device slice
const deviceSlice = createSlice({
  name: "device",
  initialState,
  reducers: {
    // get available devices
    getAvailableDevicesRequest: (
      state: device.DeviceStateType,
      action: PayloadAction<any>
    ) => {
      state.availableDevices.isLoading = true;
      state.availableDevices.data = [];
      state.availableDevices.error = null;
    },
    getAvailableDevicesSuccess: (
      state: device.DeviceStateType,
      action: PayloadAction<any>
    ) => {
      state.availableDevices.isLoading = false;
      state.availableDevices.data = action.payload;
      state.availableDevices.error = null;
    },
    getAvailableDevicesError: (
      state: device.DeviceStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.availableDevices.isLoading = false;
      state.availableDevices.data = [];
      state.availableDevices.error = error;
    },

    // get connected devices
    getConnectedDevicesRequest: (
      state: device.DeviceStateType,
      action: PayloadAction<any>
    ) => {
      state.connectedDevices.isLoading = true;
      state.connectedDevices.data = [];
      state.connectedDevices.error = null;
    },
    getConnectedDevicesSuccess: (
      state: device.DeviceStateType,
      action: PayloadAction<any>
    ) => {
      state.connectedDevices.isLoading = false;
      state.connectedDevices.data = action.payload;
      state.connectedDevices.error = null;
    },
    getConnectedDevicesError: (
      state: device.DeviceStateType,
      { payload: error }: PayloadAction<string>
    ) => {
      state.connectedDevices.isLoading = false;
      state.connectedDevices.data = [];
      state.connectedDevices.error = error;
    },
  },
});

// Export actions and reducer
export const {
  // get available devices
  getAvailableDevicesRequest,
  getAvailableDevicesSuccess,
  getAvailableDevicesError,

  // get connected devices
  getConnectedDevicesRequest,
  getConnectedDevicesSuccess,
  getConnectedDevicesError,
} = deviceSlice.actions;

export default deviceSlice.reducer;
